/**
 * 读菜单接口回「Can not found menu.」= 这次带的 menuId 已经不在用（菜单被归档 / 下线 / 不是这家店的）。
 * 后端读接口带显式 menuId 时就是这么拒的（`MenuResolutionService.php:308-331`）：
 * - get-product-list / get-product / get-recommendations：`commonFormResponse('Can not found menu.')`
 *   （`CustomerControllers/DefaultController.php:515`、`:659`、`:3621`）；
 * - other-action `get_cart_recommend`：`{success:false, error:['Can not found menu.']}`（`:3344`）。
 *
 * 处理（owner D96 末句）：不弹窗、清掉 menuId、带 context 重新请求一次 get-menu、用新菜单再读一次；
 * 再失败就把错误交给调用方（与其它读失败一样），**绝不循环**。
 *
 * 只认这次请求**真带了 menuId** 的：没带 menuId 时后端回同一句（门店根本没有菜单），那是今天就有的错误，照今天弹提示。
 */

export const MENU_NOT_FOUND_MESSAGE = 'Can not found menu.'

/** 会带 menuId 的读菜单接口（get-menu 自己从不带 menuId，不在内） */
export const MENU_READ_URLS = [
  '/customer/default/get-product-list',
  '/customer/default/get-product',
  '/customer/default/get-recommendations',
  '/customer/default/other-action'
]

/** 后端的错误体是不是「菜单不在用」（form 对象 / get_cart_recommend 的数组 / 拦截器 reject 出来的裸字符串） */
export function isMenuNotFoundPayload(error) {
  if (typeof error === 'string') return error === MENU_NOT_FOUND_MESSAGE
  if (Array.isArray(error)) return error[0] === MENU_NOT_FOUND_MESSAGE
  return !!error && typeof error === 'object' && error.message === MENU_NOT_FOUND_MESSAGE
}

/** 请求体（响应拦截器里 config.data 已经被 axios 序列化成 JSON 串；坏串 / 非对象 ⇒ null） */
export function requestBodyOf(data) {
  let body = data
  if (typeof body === 'string') {
    try {
      body = JSON.parse(body)
    } catch (e) {
      return null
    }
  }
  return body && typeof body === 'object' && !Array.isArray(body) ? body : null
}

/** 这次请求带的 menuId */
export function menuIdOfRequestData(data) {
  const body = requestBodyOf(data)
  return body && typeof body.menuId === 'string' ? body.menuId : ''
}

/** 响应拦截器用：这条失败是不是「带了 menuId 的读菜单请求，菜单已不在用」 */
export function isMenuGoneResponse(url, error, requestData) {
  const path = typeof url === 'string' ? url.split('?')[0] : ''
  if (!MENU_READ_URLS.includes(path)) return false
  if (!menuIdOfRequestData(requestData)) return false
  return isMenuNotFoundPayload(error)
}

/** 拦截器 reject 出去的标记（调用方据此重新解析；各页原有的 `.catch(console.log)` 照常接得住） */
export function menuGoneError() {
  return { menuGone: true, message: MENU_NOT_FOUND_MESSAGE }
}

export function isMenuGoneError(error) {
  return !!error && typeof error === 'object' && error.menuGone === true
}

/**
 * 读一次；菜单不在用 ⇒ `reresolve()`（清 menuId + 重新 get-menu）⇒ 再读一次。最多一次重新解析。
 * @param {Function} read 无参，返回 Promise；**每次调用时**才去 store 取 menuId（重新解析之后自然用新的）
 * @param {Function} reresolve 无参，返回 Promise（或同步）
 */
export async function readWithMenuRetry(read, reresolve) {
  try {
    return await read()
  } catch (error) {
    if (!isMenuGoneError(error)) throw error
  }
  await reresolve()
  return read()
}
